import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { useActualLanguage } from '../hooks';

type Props = {
  value: string;
  className?: string;
}

export function StringDateTimeFromNow(
  {
    value,
    className
  }: Props
) {
  const actualLenguage = useActualLanguage();
  const valueCalculated = useMemo(() => (
    DateTime
      .fromISO(value)
      .toRelative({ locale: actualLenguage })
  ), [value, actualLenguage]);
  return (
    <span className={className}>
      {valueCalculated}
    </span>
  );
}

export default StringDateTimeFromNow;
